import React from 'react';
import { Icon } from 'antd';

function DeleteContent(props) {
    const { className, onClick, children } = props;
    return (
        <div className={className} style={{ wordBreak: 'break-word' }}>
            {children}
            <Icon
                type="close"
                className="icon-delete"
                onClick={() => onClick()}
            />
        </div>
    )
}

export default DeleteContent;


// WEBPACK FOOTER //
// ./src/components/basicElement/DeleteContent.js